import {
  postElegibilidad,
  postLocation,
  setElegibilityForm,
} from '../../config/apiSinToken'

export const saveElegibilityForm = async (form) => {
  const data = await setElegibilityForm(
    `api/v1/ElegibilityAnswers/saveForm`,
    form,
  )
  return data
}
export const saveDrafElegibilityForm = async (form) => {
  const data = await setElegibilityForm(
    `api/v1/ElegibilityAnswers/UpdateForm`,
    form,
  )
  return data
}

export const saveLocation = async (form) => {
  const data = await postLocation(
    `api/v1/ProjectDevelopmentLocation/insertLocation`,
    form,
  )
  return data
}

// funcion para el modal 36 Seccion 3 (perdida de activos debido a eventos relacionados con el cambio climatico)
export const insertAsset = async (form) => {
  const data = await postElegibilidad(
    `api/v1/AssetsLossClimate/insertAsset`,
    form,
  )
  return data
}

// funcion para el modal 33 Seccion 3 (Datos de la produccion y hectareas afectadas)
export const insertProductionandLoss = async (form) => {
  const data = await postElegibilidad(
    `api/v1/ProductionAndLossesByClimate/insertProductionAndLoss`,
    form,
  )
  return data
}

// funcion para la tablla 9.3.1export const insertProductionandLoss = async (form) => {
export const insertActivity = async (form) => {
  const data = await postElegibilidad(
    `api/v1/ProductiveActivitiesPlanning/insertActivity`,
    form,
  )
  return data
}

// Funcion para la tabla 3.9.3
export const insertBarrier = async (form) => {
  const data = await postElegibilidad(
    `api/v1/MarketAccessBarriers/insertBarrier`,
    form,
  )
  return data
}

// Funcion para la tabla 3.9.6
export const insertEnergyUsedProduction = async (form) => {
  const data = await postElegibilidad(
    `api/v1/EnergyUsedProduction/insert`,
    form,
  )
  return data
}

// Funcion para la tabla 3.9.9
export const insertManagementSoilsPractices = async (form) => {
  const data = await postElegibilidad(
    `api/v1/ManagementSoilsPractices/insert`,
    form,
  )
  return data
}

// Funcion para la tabla 4.1 seccion 4
export const insertGenderActivities = async (form) => {
  const data = await postElegibilidad(`api/v1/GenderActivities/insert`, form)
  return data
}

// Funcion para la tabla 5.2 seccion 5
export const insertAdaptationMeasures = async (form) => {
  const data = await postElegibilidad(`api/v1/AdaptationMeasures/insert`, form)
  return data
}

// Funcion para el modal 3.9.7 seccion 3
export const insertIrrigationSystem = async (form) => {
  const data = await postElegibilidad(
    `api/v1/IrrigationSystems/updateIrrigationSystem`,
    form,
  )
  return data
}

// Funcion para la tabla 5.3 dataGanttDev seccion 5
export const insertImplementationSchedule = async (form) => {
  const data = await postElegibilidad(
    `api/v1/ImplementationSchedule/insert`,
    form,
  )
  return data
}
// Secion 6
export const insertManagementPlanMitigation = async (form) => {
  const data = await postElegibilidad(
    `api/v1/ManagementPlanMitigations/insert`,
    form,
  )
  return data
}

// Funcion para la tabla 5.4 (presupuesto) seccion 5
export const insertSubprojectBudget = async (form) => {
  const data = await postElegibilidad(`api/v1/SubprojectBudget/insert`, form)
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 07-11-2022
 * Description: Funcion para crear un nuevo test
 */
export const createTestWorkshop = async (form) => {
  const data = await postElegibilidad(
    `api/v1/Workshop/Test/Create?CodWorkShop=${form}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 19-04-2023
 * Description: Funcion historico
 */
export const UploadReportElegibility = async (form) => {
  const data = await postElegibilidad(
    `api/v1/AzureBlobStorageService/Upload/Report-Elegibility`,
    form,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 07-07-2023
 * Description: insert new irrigitacionm system
 */
export const InsertIrrigationSystemNew = async (form) => {
  const data = await postElegibilidad(
    `api/v1/IrrigationSystems/InsertIrrigationSystem`,
    form,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 10-03-2023
 * Description: insert fertilizer system
 */
export const InsertUsedFertilizers = async (form) => {
  const data = await postElegibilidad(`api/v1/UsedFertilizers/insert`, form)
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 03-22-2024
 * Description: has an action plan
 */
export const InsertHasAnActionPlan = async (idElegibilityForm, actionPlan) => {
  const data = await postElegibilidad(
    `api/v1/ElegibilityAnswers/HasAnActionPlan/${idElegibilityForm}?HasAnActionPlan=${actionPlan}`,
  )
  return data
}
